// These endpoints create records immediately; only advance on a confirmed result.
export async function registrationRequest(url: string, payload: unknown, message: string, conflictMessage?: string) {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(payload),
    })
    const result = await response.json()
    if (!response.ok || result.status === false || !result.data?.id) {
      throw new Error(response.status === 409 && conflictMessage ? conflictMessage : message)
    }
    return result
  } catch (error) {
    if (error instanceof Error && (error.message === message || error.message === conflictMessage)) throw error
    throw new Error(message)
  }
}

// Tracking must not interrupt a completed write or cause it to be submitted again.
export function trackRegistration(track: () => void) {
  try { track() } catch { /* Registration can continue when analytics is unavailable. */ }
}
